import {useEffect} from 'react';

export const useDebouncedEffect = (callback: () => void, delay?: number) => {
  useEffect(() => {
    const timer = setTimeout(callback, delay || 1000);

    return () => clearTimeout(timer);
  }, [callback, delay]);
};
